export default defineNuxtRouteMiddleware((to, from) => {
  // Define the paths you want to disable
  const disabledPaths = ['/billings'];

  if (disabledPaths.includes(to.path)) {
    return abortNavigation();
  }
});